import moment from "moment";
import { convertKeysToCamelCase } from "./utils/general-utils";
import { t } from "./multi-language/multi-lang.service";
export var personalData = function (user) {
    user = convertKeysToCamelCase(user);
    return ({
        "gender": user.gender,
        "dob": moment(user.dateOfBirth).format('MMM DD, YYYY'),
        "physician": user.physicianName,
        "weight": "".concat(Number(user.weight).toFixed(1).replace('.0', ''), " ").concat(t("charts.units.".concat(user.weightUnit))),
        "height": "".concat(Number(user.height).toFixed(+(user.heightUnit === 'ft')), " ").concat(t("charts.units.".concat(user.heightUnit))),
    });
};
export var getUserFullName = function (user) {
    user = convertKeysToCamelCase(user);
    return "".concat(user.firstName, " ").concat(user.lastName);
};
export var ecgBeatMsDuration = 3.90625;
export var REPORT_TYPES = {
    ARRYTH: 'arryth_report',
    MONTHLY: 'monthly_report',
    BP: 'bp_report',
    PWV: 'pwv_report',
    AF: 'af_report',
    RT: 'realtime_report',
    NIGHT: 'night_report',
    DAILY: 'daily_report'
};
export var initialMesutments = function (data) { return ({
    "Pulse Rate": {
        title: 'Pulse Rate',
        unit: 'bpm'
    },
    "Respiratory Rate": {
        title: 'Respiratory Rate',
        unit: 'rpm'
    },
    "Blood Pressure": {
        title: 'Blood Pressure',
        unit: 'mmHg'
    },
    SpO2: {
        title: 'SpO2',
        unit: '%'
    },
    "Body Temp": {
        title: "Body Temp",
        unit: data.temperatureUnit || "°C"
    },
    Weight: {
        title: 'Weight',
        unit: data.weightUnit || 'Kg'
    },
    Glucose: {
        title: 'Glucose',
        unit: data.glucoseUnit || 'mg/dL'
    },
    Steps: {
        title: 'Steps',
    },
    Calories: {
        title: 'Calories',
        unit: 'kcal'
    },
    'Pwv Weekly': {
        title: 'pwv_weekly',
        unit: 'pwv_weekly'
    }
}); };
export var MEASURMENTS_UNITS = {
    "Blood Pressure": 'mmHg',
    "Heart Rate": 'bpm',
    "Respiratory Rate": 'rpm',
    'SpO2': '%'
};
export var WELLNESS_TITLES = {
    sleep: 'Sleeping hrs',
    calories: 'kcal',
    steps: 'Steps',
};
export var MEDICAL_QUESTIONS_CONDITAIONS = [
    'COPD',
    'CHF',
    'A-Fib',
    'Hypertension',
    'Sleep Apnea',
    'Diabetes',
    'Asthma',
    'Epilepsy',
    'Stroke',
    'Heart attack - MI',
    'Vascular Disease'
];
export var MEDICAL_QUESTION_ANSWERS = {
    "ans_1": "No",
    "ans_2": "Yes",
    "ans_3": "Don't Know",
};
export var EPILEPSY_MEDICAL_QUESTION_ANSWERS = {
    "ans_1": "No",
    "ans_2": "Yes",
};
export var AF_MEDICAL_QUESTION_ANSWERS = {
    "ans_1": "Paroxysmal",
    "ans_2": "Persistent",
    "ans_3": "Long-standing persistent",
    "ans_4": "Permanent",
    "ans_5": "Yes, unknown type",
    "ans_6": "No",
    "ans_7": "Don't Know",
};
export var CHARTS_TITLE = {
    'blood_pressure': 'Blood Pressure',
    'respiratory_rate': 'Respiratory Rate',
    'pulse_rate': 'Pulse Rate',
    'body_temp': 'Body Temp',
    spo2: 'Oxygen Saturation',
    weight: 'Weight',
    glucose: 'Glucose',
    hrv_pr: 'HRV',
    hrv_lfhf: 'HRV',
    pwv: 'PWV',
    steps: 'Steps',
    calories: 'Calories burnt',
    sleep: 'Sleeping Hours',
    medications: 'Medications reminder'
};
export var ARRYTH_APPEND_TEXT_KEYS = ['rpv', 'pi', 'pwv', 'ppg'];
export var ECG_PARAMS_KEYS = ['qt', 'qtc', 'qtcf', 'pr_interval', 'qrs_duration' /*, 'qrs_axis'*/];
export var ARRYTH_APPEND_TEXT = [
    {
        textKey: 'RPV (Relative Pulse Volume)',
        text: 'The ratio of the area of a specific PPG pulse to the area of the median PPG pulse area. RPV is denoted in percentages over the PPG strip.',
    },
    {
        textKey: 'PI (Perfusion Index)',
        text: 'is a numerical value that reflects the strength of the pulsatile signal in a patient\'s peripheral perfusion, usually measured by a pulse oximeter. The PI is calculated by dividing the pulsatile blood flow component by the non-pulsatile blood flow component, expressed as a percentage or decimal value. In other words, PI is a measure of the amount of blood flow in the patient\'s tissues, particularly the peripheral tissues such as fingers, wrists, or toes. It is a useful clinical parameter to monitor a patient\'s perfusion status, especially in critical care settings, where it can provide an early warning of deteriorating hemodynamic conditions. High PI values may indicate good peripheral perfusion, while low PI values may indicate poor peripheral perfusion, which could be due to factors such as hypotension, hypothermia, hypovolemia, or peripheral vascular disease. However, it\'s important to note that the interpretation of PI values should be done in conjunction with other clinical parameters and the patient\'s overall condition.',
    },
    {
        textKey: 'PWV (Pulse Wave Velocity)',
        text: 'This is a measure of the speed at which the arterial pressure wave travels through the arterial system. It is a widely used indicator of arterial stiffness and is used as a marker of cardiovascular health. PWV is typically measured by recording the pressure waveform at two different sites along an arterial segment. The distance between the two recording sites is then divided by the time taken for the pressure wave to travel between them, resulting in a velocity measurement in meters per second (m/s) or centimetres per second (cm/s). A higher PWV value indicates stiffer, less compliant arteries, which is associated with increased cardiovascular risk. This is because stiffer arteries can lead to increased systolic blood pressure and pulsatile stress on the heart, which can increase the risk of cardiovascular events such as heart attack or stroke. On the other hand, a lower PWV value is associated with better arterial compliance and reduced cardiovascular risk. PWV measurement has been incorporated into many clinical studies and is being used as a diagnostic tool in the evaluation of cardiovascular diseases, including hypertension, coronary artery disease, and heart failure.',
    },
    {
        textKey: 'PPG (Photoplethysmography)',
        text: 'An optical technique for detecting blood volume changes in the microvascular bed of tissue.',
    }
];
export var CARDIO_INTEGRAL_SUMMARY = {
    overall: {
        title: 'Overall wellbeing',
        unit: '(%)',
        descriptionKey: 'Overall wellbeing',
        description: 'Overall heart wellbeing score is a general estimation of your current physical and emotional wellbeing on the scale from ideal state (100-75%) to a bit imbalanced (75-50%) and moderately imbalanced (50-25%).',
        fixNum: 0
    },
    myocardium: {
        title: 'Myocardium Score',
        unit: '(%)',
        descriptionKey: 'Myocardium Score',
        description: 'Myocardium score is a basic estimation of heart muscle state. It reflects the state of the heart muscle (myocardium) and cardiac conduction system.',
        fixNum: 0
    },
    stamina: {
        title: 'Stamina Score',
        unit: '(%)',
        descriptionKey: 'Stamina Score',
        description: 'Stamina is a measure of the total functional reserves of your body. The functional reserve is the supply of vitality,  which can be used for adaptation, in other words, in response to various "challenges", internal and / or external adverse circumstances. This integral indicator is based on a combination of various parameters of Heart Rate Variability. Heart Rate Variability (HRV) is a small fluctuation in the time intervals between heartbeats, reflecting multilevel autonomic regulation of heart rate.',
        fixNum: 0
    },
    emotional: {
        title: 'Emotional Score',
        descriptionKey: 'Emotional score',
        description: 'Cardio interval spectral analysis based index. Represents the emotional state at the present time.',
        fixNum: 2
    },
    risk_cardiovascular_events: {
        title: 'Risk of heart disorders',
        descriptionKey: 'Risk of heart disorders',
        description: 'It is an integral score reflecting the probability of sudden cardiac death based on HRV and ECG time and amplitude parameters.',
        fixNum: 0
    },
    heart_rhythm_disturbances: {
        title: 'Heart rhythm disorders',
        descriptionKey: 'Heart rhythm disorders',
        description: 'Heart rhythm disorders is a condition that involves irregularities in heart beats, frequency and sequence in excitation and contraction of the heart. Heart rhythm disorder is classified by a degree of hazard. Availability of threatening ventricular arrhythmias is a strong predictor of "arrhythmic" deaths. Less dangerous arrhythmias indicate about functional reserve decrease.',
        fixNum: 0
    },
    stress: {
        title: 'Stress level Normal',
        descriptionKey: 'Stress level Normal',
        description: 'Stress is a physical, mental, or emotional factor that causes bodily or mental tension. Stress Index measures physiological stress, which has proven to be an reliable predictor of future health problems in cases of prolonged high physiological stress levels.',
        fixNum: 0
    },
    // heart_biological_age: {
    //   title: 'Heart biological age',
    //   descriptionKey: '',
    //   description: '',
    //   fixNum: 0
    // }
};
// export const CARDIO_HRV = (): any => ({
//   HEART_RATE: {
//     title: t(`arryth_report.cardio.hr.hrv.heart_rate.title`),
//     descriptionKey: t(`arryth_report.cardio.hr.hrv.heart_rate.title`),
//     description: t(`arryth_report.cardio.hr.hrv.heart_rate.desc`),
//     fixNum: 0
//   },
//   SDNN: {
//     title: t(`arryth_report.cardio.hr.hrv.sdnn.title`),
//     descriptionKey: t(`arryth_report.cardio.hr.hrv.sdnn.title`),
//     description: t(`arryth_report.cardio.hr.hrv.sdnn.desc`),
//     fixNum: 0
//   },
//   RMSSD: {
//     title: t(`arryth_report.cardio.hr.hrv.rmssd.title`),
//     descriptionKey: t(`arryth_report.cardio.hr.hrv.rmssd.title`),
//     description: t(`arryth_report.cardio.hr.hrv.rmssd.desc`),
//     fixNum: 0
//   },
//   STRESS_INDEX: {
//     title: t(`arryth_report.cardio.hr.hrv.stress_index.title`),
//     descriptionKey: t(`arryth_report.cardio.hr.hrv.stress_index.title`),
//     description: t(`arryth_report.cardio.hr.hrv.stress_index.desc`),
//     fixNum: 0
//   },
//   TRIANGULAR_INDEX: {
//     title: t(`arryth_report.cardio.hr.hrv.triangular_index.title`),
//     descriptionKey: t(`arryth_report.cardio.hr.hrv.triangular_index.title`),
//     description: t(`arryth_report.cardio.hr.hrv.triangular_index.desc`),
//     fixNum: 0
//   },
//   PNN50: {
//     title: t(`arryth_report.cardio.hr.hrv.pnn50.title`),
//     descriptionKey: t(`arryth_report.cardio.hr.hrv.pnn50.title`),
//     description: t(`arryth_report.cardio.hr.hrv.pnn50.desc`),
//     fixNum: 0
//   },
//   PNN20: {
//     title: t(`arryth_report.cardio.hr.hrv.pnn20.title`),
//     descriptionKey: t(`arryth_report.cardio.hr.hrv.pnn20.title`),
//     description: t(`arryth_report.cardio.hr.hrv.pnn20.desc`),
//     fixNum: 0
//   },
//   SDSD: {
//     title: t(`arryth_report.cardio.hr.hrv.sdsd.title`),
//     descriptionKey: t(`arryth_report.cardio.hr.hrv.sdsd.title`),
//     description: t(`arryth_report.cardio.hr.hrv.sdsd.desc`),
//     fixNum: 0
//   },
//   VLF_HF: {
//     title: t(`arryth_report.cardio.hr.hrv.vlf_hf.title`),
//     descriptionKey: t(`arryth_report.cardio.hr.hrv.vlf_hf.title`),
//     description: t(`arryth_report.cardio.hr.hrv.vlf_hf.desc`),
//     fixNum: 2
//   },
//   IAE: {
//     title: t(`arryth_report.cardio.hr.hrv.iae.title`),
//     descriptionKey: t(`arryth_report.cardio.hr.hrv.iae.title`),
//     description: t(`arryth_report.cardio.hr.hrv.iae.desc`),
//     fixNum: 2
//   },
//   TOTAL_POWER: {
//     title: t(`arryth_report.cardio.hr.hrv.total_power.title`),
//     descriptionKey: t(`arryth_report.cardio.hr.hrv.total_power.title`),
//     description: t(`arryth_report.cardio.hr.hrv.total_power.desc`),
//     fixNum: 2
//   },
//   ACTIVITY_OF_VASOMOTOR_CENTERS: {
//     title: t(`arryth_report.cardio.hr.hrv.activity_of_vasomotor_centers.title`),
//     descriptionKey: t(`arryth_report.cardio.hr.hrv.activity_of_vasomotor_centers.title`),
//     description: t(`arryth_report.cardio.hr.hrv.activity_of_vasomotor_centers.desc`),
//     fixNum: 2
//   },
//   ACTIVITY_OF_SUBCORTICAL_CENTERS: {
//     title: t(`arryth_report.cardio.hr.hrv.activity_of_subcotical_centers.title`),
//     descriptionKey: t(`arryth_report.cardio.hr.hrv.activity_of_subcotical_centers.title`),
//     description: t(`arryth_report.cardio.hr.hrv.activity_of_subcotical_centers.desc`),
//     fixNum: 2
//   },
//   ENTROPY: {
//     title: t(`arryth_report.cardio.hr.hrv.entropy.title`),
//     descriptionKey: t(`arryth_report.cardio.hr.hrv.entropy.title`),
//     description: t(`arryth_report.cardio.hr.hrv.entropy.desc`),
//     fixNum: 2
//   },
//   FRACTAL_INDEX: {
//     title: t(`arryth_report.cardio.hr.hrv.fractal_index.title`),
//     descriptionKey: t(`arryth_report.cardio.hr.hrv.fractal_index.title`),
//     description: t(`arryth_report.cardio.hr.hrv.fractal_index.desc`),
//     fixNum: 2
//   },
//   DFA: {
//     title: t(`arryth_report.cardio.hr.hrv.dfa.title`),
//     descriptionKey: t(`arryth_report.cardio.hr.hrv.dfa.title`),
//     description: t(`arryth_report.cardio.hr.hrv.dfa.desc`),
//     fixNum: 0
//   },
//   VLF: {
//     title: t(`arryth_report.cardio.hr.hrv.vlf.title`),
//     descriptionKey: t(`arryth_report.cardio.hr.hrv.vlf.title`),
//     description: t(`arryth_report.cardio.hr.hrv.vlf.desc`),
//     fixNum: 0
//   },
//   LF: {
//     title: t(`arryth_report.cardio.hr.hrv.lf.title`),
//     descriptionKey: t(`arryth_report.cardio.hr.hrv.lf.title`),
//     description: t(`arryth_report.cardio.hr.hrv.lf.desc`),
//     fixNum: 0
//   },
//   HF: {
//     title: t(`arryth_report.cardio.hr.hrv.hf.title`),
//     descriptionKey: t(`arryth_report.cardio.hr.hrv.hf.title`),
//     description: t(`arryth_report.cardio.hr.hrv.hf.desc`),
//     fixNum: 0
//   },
//   LFn: {
//     title: t(`arryth_report.cardio.hr.hrv.lfn.title`),
//     descriptionKey: t(`arryth_report.cardio.hr.hrv.lfn.title`),
//     description: t(`arryth_report.cardio.hr.hrv.lfn.desc`),
//     fixNum: 0
//   },
//   HFn: {
//     title: t(`arryth_report.cardio.hr.hrv.hfn.title`),
//     descriptionKey: t(`arryth_report.cardio.hr.hrv.hfn.title`),
//     description: t(`arryth_report.cardio.hr.hrv.hfn.desc`),
//     fixNum: 0
//   }
// })
export var CARDIO_HRV = {
    heart_rate: {
        title: 'HR (bpm)',
        descriptionKey: 'HR (bpm)',
        description: 'Heart rate (HR) is the speed of the heartbeat measured by the number of contractions of the heart per minute (bpm)',
        fixNum: 0
    },
    sdnn: {
        title: 'SDNN (ms)',
        descriptionKey: 'SDNN (ms)',
        description: 'Standard deviation of Normal-to-Normal intervals is the measure of overall heart rate variability, the level of overall adaptive potential of autonomic regulation.',
        fixNum: 0
    },
    rmssd: {
        title: 'RMSSD (ms)',
        descriptionKey: 'RMSSD (ms)',
        description: 'Measures beat-to-beat variability, represents rapid fluctuations in heart rate, characterises parasympathetic regulations.',
        fixNum: 0
    },
    stress_index: {
        title: 'Stress - index',
        descriptionKey: 'Stress - index',
        description: 'Stress is a physical, mental, or emotional factor that causes bodily or mental tension.Stress Index measures physiological stress, which has proven to be an reliable predictor of future health problems in cases of prolonged high physiological stress levels.',
        fixNum: 0
    },
    triangular_index: {
        title: 'Triangular index',
        descriptionKey: 'Triangular index',
        description: 'Represents primarily the parasympathetic tone.',
        fixNum: 0
    },
    pnn50: {
        title: 'PNN50 (%)',
        descriptionKey: 'PNN50 (%)',
        description: 'Represents the activity rate of the parasympathetic regulation.',
        fixNum: 0
    },
    pnn20: {
        title: 'PNN20 (%)',
        descriptionKey: 'PNN20 (%)',
        description: 'Represents the activity rate of the parasympathetic regulationץ',
        fixNum: 0
    },
    sdsd: {
        title: 'SDSD (ms)',
        descriptionKey: 'SDSD (ms)',
        description: 'Standard deviation of differences between adjacent NN intervals. It characterises the acidification of myocardial lactate.',
        fixNum: 0
    },
    vlf_hf: {
        title: 'Autonomic balance 1 (LF/HF)',
        descriptionKey: 'Autonomic balance 1(LF / HF)',
        description: 'Ratio of sympathetic and parasympathetic regulation.',
        fixNum: 2
    },
    iae: {
        title: 'Autonomic balance 2 (IAE)',
        descriptionKey: 'Autonomic balance 2(IAE)',
        description: 'Autonomic balance index to represent the ratio of sympathetic and parasympathetic parts of the autonomic nervous system.',
        fixNum: 2
    },
    total_power: {
        title: 'General level of bioenergy (TP)',
        descriptionKey: 'General level of bioenergy(TP)',
        description: 'Bioenergy indicates a level of long - term durability of heart as well as sufficiency of fitness activity.',
        fixNum: 2
    },
    activity_of_vasomotor_centers: {
        title: 'Activity of vasomotors centers of regulation',
        descriptionKey: 'Activity of vasomotor centers of regulation',
        description: 'Specific activity of medulla oblongata vasomotor center.',
        fixNum: 2
    },
    activity_of_subcortical_centers: {
        title: 'Activity of subcortical centers',
        descriptionKey: 'Activity of subcortical centers',
        description: 'Specific activity of subcortical sympathetic nerve centers ergotropic.',
        fixNum: 2
    },
    entropy: {
        title: 'Entropy',
        descriptionKey: 'Entropy',
        description: 'Entropy of cardiointervals.',
        fixNum: 2
    },
    fractal_index: {
        title: 'Fractal index',
        descriptionKey: 'Fractal index',
        description: 'Similarity degree of cardiointeravls.',
        fixNum: 2
    },
    dfa: {
        title: 'DFA',
        descriptionKey: 'DFA',
        description: 'Similarity degree of cardio intervals, another approach.',
        fixNum: 0
    },
    vlf: {
        title: 'VLF',
        descriptionKey: 'VLF',
        description: 'Absolute spectral power in domain of very low frequency waves, represents the measure of subcortical sympathetic activity ergotropic centers.',
        fixNum: 0
    },
    lf: {
        title: 'LF',
        descriptionKey: 'LF',
        description: 'Absolute spectral power in domain of low frequency waves, represents a measure of the baroreflex center activity(primarily - sympathetic activity).',
        fixNum: 0
    },
    hf: {
        title: 'HF',
        descriptionKey: 'HF',
        description: 'Absolute spectral power in domain of high frequency waves, represents the measure of nuclei acitivity of the vagus nerve (parasympathetic activity).',
        fixNum: 0
    },
    lfn: {
        title: 'LFn',
        descriptionKey: ' LFn',
        description: 'Normalized spectral power in domain of low frequency waves, represents a measure of the baroreflex center activity (primarily - sympathetic activity).',
        fixNum: 0
    },
    hfn: {
        title: 'HFn',
        descriptionKey: 'HFn',
        description: 'Normed by the sum of LF+HF spectral capacity of high frequency waves. Represents the measure of relative contribution of the parasympathetic part of the autonomic nervous system into the regulation of heart rate.',
        fixNum: 0
    }
};
export var CARDIO_HR_EVENTS = {
    NORMAL_SINUS_RHYTHM: {
        code: 'NORMAL_SINUS_RHYTHM',
        name: 'Normal sinus rhythm ',
        description: 'The rhythm of your heartbeat, determined by the sinus node of your heart. The sinus node creates an electrical pulse that travels through your heart muscle, causing it to beat. You can think of the sinus node as a natural pacemaker. '
    },
    SINUS_TACHYCARDIA: {
        code: 'SINUS_TACHYCARDIA ',
        name: 'Sinus tachycardia ',
        description: 'The rhythm of your heartbeat, determined by the sinus node of your heart. The sinus node creates an electrical pulse that travels through your heart muscle, causing it to beat. You can think of the sinus node as a natural pacemaker. '
    },
    SINUS_BRADYCARDIA: {
        code: 'SINUS_BRADYCARDIA',
        name: 'Sinus bradycardia ',
        description: 'Sinus bradycardia is a type of slow heartbeat less than 60 times per minute. Normally, the SA node fires the signal about 60 to 100 times per minute at rest. In sinus bradycardia, the node fires less than 60 times per minute. '
    },
    SINUS_ARRHYTHMIA: {
        code: 'SINUS_ARRHYTHMIA ',
        name: 'Sinus arrhythmia ',
        description: 'Sinus Arrythmia is a normal variation in a beating of a heart. Sinus Arrythmia refers to an irregular or disorganized heart rhythm and usually asymptomatic.'
    },
    PAUSE: {
        code: 'PAUSE',
        name: 'Pause',
        description: 'Signals from the ventricles of your heart that come earlier than the natural rhythm. then followed by a pause, and then a stronger second beat because the pause allows more time for blood to fill the heart chamber. '
    },
    AV_BLOCK_1ST_DEGREE_WITH_NSR: {
        code: 'AV_BLOCK_1ST_DEGREE_WITH_NSR',
        name: 'First-degree atrioventricular block with normal sinus rhythm ',
        description: 'First-degree atrioventricular block with normal sinus rhythm is quite common and is also usually benign. The manifestation of this disorder involves a prolonged P-R interval > 200 msec. In this situation, all of the sinus impulses conduct to the AV node. Although it requires no intervention, its presence can herald certain drug toxicities. Accompanied by normal sinus rhythm, i e sinus rhythm is the normal regular rhythm of the heart set by the natural pacemaker of the heart called the sinoatrial node. '
    },
    AV_BLOCK_1ST_DEGREE_WITH_BRADY: {
        code: 'AV_BLOCK_1ST_DEGREE_WITH_BRADY',
        name: 'First-degree atrioventricular block with sinus bradycardia',
        description: 'A first-degree atrioventricular block with sinus bradycardia is quite common. The manifestation of this disorder involves a prolonged P-R interval > 200 msec. In this situation, all of the sinus impulses conduct to the AV node. Although it requires no intervention, its presence can herald certain drug toxicities. Accompanied by sinus bradycardia, i e sinus bradycardia is a regular but unusually slow heart beat (less than 60 bpm). '
    },
    AV_BLOCK_1ST_DEGREE_WITH_TACHY: {
        code: 'AV_BLOCK_1ST_DEGREE_WITH_TACHY',
        name: 'First-degree atrioventricular block with sinus tachycardia ',
        description: 'A first-degree atrioventricular block with sinus tachycardia is quite common. The manifestation of this disorder involves a prolonged P-R interval > 200 msec. In this situation, all of the sinus impulses conduct to the AV node. Although it requires no intervention, its presence can herald certain drug toxicities. Accompanied by sinus tachycardia, i e sinus tachycardia is a fast heartbeat (>100 bpm) related to rapid fiting of sinotrial (SA) node. '
    },
    PREMATURE_VENTRICULAR_CONTRACTION: {
        code: 'PREMATURE_VENTRICULAR_CONTRACTION',
        name: 'Premature ventricular contraction ',
        description: 'Premature ventricular contractions are extra heartbeats, disrupting your regular heart rhythm. Sometimes causing you to feel a fluttering or a skipped beat in your chest.'
    },
    VENTRICULAR_COUPLET: {
        code: 'VENTRICULAR_COUPLET',
        name: 'Ventricular couplet ',
        description: 'Ventricular couplets are defined as two Premature Ventricular Complexes (PVC) in a row. There is often a compensatory pause after the second premature beat.'
    },
    VENTRICULAR_TRIPLET: {
        code: 'VENTRICULAR_TRIPLET',
        name: 'Ventricular triplet ',
        description: 'Ventricular triplets are defined as three Premature Ventricular Complexes (PVC) in a row. There is often a compensatory pause after the third premature beat.'
    },
    VENTRICULAR_BIGEMINY: {
        code: 'VENTRICULAR_BIGEMINY',
        name: 'Ventricular bigeminy',
        description: 'Ventricular bigeminy is a cardiac arrhythmia in which there is a single ectopic beat, or irregular heartbeat, following each regular heartbeat.'
    },
    VENTRICULAR_TRIGEMINY: {
        code: 'VENTRICULAR_TRIGEMINY',
        name: 'Ventricular trigeminy',
        description: 'Ventricular trigeminy is a cardiac arrhythmia in which there is a single ectopic beat, or irregular heartbeat, following each two regular heartbeats.'
    },
    VENTRICULAR_TACHYCARDIA: {
        code: 'VENTRICULAR_TACHYCARDIA',
        name: 'Ventricular tachycardia',
        description: 'Ventricular tachycardia (VT) is a type of arrhythmia. It occurs when the lower chamber of the heart beats too fast to pump well and the body doesn\'t receive enough oxygenated blood. '
    },
    SLOW_VENTRICULAR_TACHYCARDIA: {
        code: 'SLOW_VENTRICULAR_TACHYCARDIA',
        name: 'Slow ventricular tachycardia',
        description: 'Slow ventricular tachycardia (slow VT) is a ventricular tachycardia (VT), in which heart rate is below the typical frequency of VT.'
    },
    PREMATURE_SUPRAVENTRICULAR_CONTRACTION: {
        code: 'PREMATURE_SUPRAVENTRICULAR_CONTRACTION',
        name: 'Premature supraventricular contraction',
        description: 'Supraventricular premature beats are atrial contractions triggered by ectopic foci rather than the sinoatrial node. They arise within the atria (atrial premature beats) or, through retrograde conduction, in the atrioventricular node (junctional premature beats).'
    },
    ATRIAL_COUPLET: {
        code: 'ATRIAL_COUPLET',
        name: 'Atrial couplet',
        description: 'Atrial couplets are defined as two Premature Atrial Complexes (PAC) in a row. There is often a compensatory pause after the second premature beat.'
    },
    ATRIAL_RUN: {
        code: 'ATRIAL_RUN',
        name: 'Atrial run',
        description: 'Atrial run is three or more Premature Atrial Complexes (PAC) in a row.'
    },
    ATRIAL_BIGEMINY: {
        code: 'ATRIAL_BIGEMINY',
        name: 'Atrial bigeminy ',
        description: 'Atrial bigeminy is a cardiac arrhythmia in which there is a single atrial ectopic beat, or irregular heartbeat, following each regular heartbeat.'
    },
    ATRIAL_TRIGEMINY: {
        code: 'ATRIAL_TRIGEMINY',
        name: 'Atrial trigeminy',
        description: 'Atrial trigeminy is a cardiac arrhythmia in which there is a single atrial ectopic beat, or irregular heartbeat, following each two regular heartbeats.'
    },
    ATRIAL_TRIPLET: {
        code: 'ATRIAL_TRIPLET',
        name: 'Atrial Triplet',
        description: 'Atrial triplets are defined as three Premature Atrial Complexes (PAC) in a row.'
    },
    ATRIAL_FIBRILLATION: {
        code: 'ATRIAL_FIBRILLATION',
        name: 'Atrial fibrillation',
        description: 'The heart\'s upper chambers beat chaotically and irregularly. For many people, it may have no symptoms. In some cases, A-fib may cause a fast, pounding heartbeat, shortness of breath or weakness.'
    },
    ATRIAL_FLUTTER: {
        code: 'ATRIAL_FLUTTER',
        name: 'Atrial flutter',
        description: 'Atrial flutter (AFL) is a coordinated rapid beating of the atria. Atrial flutter is the second most common tachyarrhythmia. It is characterized by a sudden-onset (usually) regular abnormal heart rhythm on an electrocardiogram (ECG) in which the heart rate is fast.'
    },
    SUPRAVENTRICULAR_TACHYCARDIA: {
        code: 'SUPRAVENTRICULAR_TACHYCARDIA',
        name: 'Supraventricular tachycardia',
        description: 'Supraventricular tachycardia (SVT) is an abnormally fast or erratic heartbeat that affects the heart\'s upper chambers'
    },
    INTERVENTRICULAR_CONDUCTION_DELAY: {
        code: 'INTERVENTRICULAR_CONDUCTION_DELAY',
        name: 'Interventricular conduction delay',
        description: 'Interventricula condaction delay is are conduction disorders with QRS >120ms without the criteria of complete or incomplete bundle-branch block'
    },
    NSR_WITH_IVCD: {
        code: 'NSR_WITH_IVCD',
        name: 'Normal sinus rhythm with interventricular conduction delay',
        description: 'Normal sinus rhythm which is accompanied by intraventricular conduction delay, i e QRS duration > 100 ms.'
    },
    BRADY_WITH_IVCD: {
        code: 'BRADY_WITH_IVCD',
        name: 'Sinus bradycardia with interventricular conduction delay',
        description: 'Sinus bradycardia which is accompanied by intraventricular conduction delay i e QRS duration > 100 ms.'
    },
    TACHY_WITH_IVCD: {
        code: 'TACHY_WITH_IVCD',
        name: 'Sinus tachycardia with interventricular conduction delay',
        description: 'Sinus tachycardia which is accompanied by intraventricular conduction delay i e QRS duration > 120 ms.'
    },
    ARTIFACT: {
        code: 'ARTIFACT',
        name: 'Artifact',
        description: 'Artifacts are distorted signals created when you move or unintentionally reposition an electrical device. Some rhythmic motions (such as shivering or tremors) can create the illusion of cardiac arrhythmia.'
    },
    NOISE: {
        code: 'NOISE',
        name: 'Noise',
        description: 'Noise are distorted signals caused by secondary internal or external sources, such as muscle movement or interference from an electrical device.'
    },
    UNCLASSIFIED_RHYTHM: {
        code: 'UNCLASSIFIED_RHYTHM',
        name: 'Unclassified rhythm',
        description: 'This are distorted signals created when you move or unintentionally reposition an electrical device.'
    },
    UNCLASSIFIED_COMPLEX: {
        code: 'UNCLASSIFIED_COMPLEX',
        name: 'Unclassified complex',
        description: 'Same as artifacts which are distorted signals created when you move or unintentionally reposition an electrical device.'
    }
};
export var ARRYTH_KEYS_TO_TYPES = {
    ecg_af: 'atrial_fibrillation',
    ppg_af: 'atrial_fibrillation',
    hpr: 'high_pr',
    fpr: 'fluctuating_pr',
    stc: 'sinus_tachycardia',
    sbc: 'sinus_bradycardia',
    sar: 'sinus_arrhythmia',
    pau: 'pause',
    fab: 'av_block_1st_degree_with_nsr',
    fsb: 'av_block_1st_degree_with_brady',
    fst: 'av_block_1st_degree_with_tachy',
    pvc: 'premature_ventricular_contraction',
    vcp: 'ventricular_couplet',
    vtp: 'ventricular_triplet',
    vbg: 'ventricular_bigeminy',
    vtg: 'ventricular_trigeminy',
    vta: 'ventricular_tachycardia',
    lvt: 'slow_ventricular_tachycardia',
    psc: 'premature_supraventricular_contraction',
    atc: 'atrial_couplet',
    atr: 'atrial_run',
    abb: 'atrial_bigeminy',
    atg: 'atrial_trigeminy',
    atp: 'atrial_triplet',
    afi: 'atrial_fibrillation',
    afl: 'atrial_flutter',
    svt: 'supraventricular_tachycardia',
    icd: 'interventricular_conduction_delay',
    nsi: 'nsr_with_ivcd',
    sbi: 'brady_with_ivcd',
    sti: 'tachy_with_ivcd'
};
export var MEASUREMENTS_TITLE = {
    'blood_pressure': 'Blood Pressure',
    'respiratory_rate': 'Respiratory Rate',
    'pulse_rate': 'Pulse Rate',
    'heart_rate': 'Heart Rate',
    'body_temp': 'Body Temp',
    spo2: 'SpO2',
    weight: 'Weight',
    glucose: 'Glucose',
    HRV: 'HRV',
    sleep: 'sleep',
};
export var pdf_width = 1160;
export var print_width = 1190;
export var print_height = 400;
export var pdf_arryth_width = 1600;
export var chart_height = 500;
export var pdf_chart_height = 420;
export var pdf_arryth_height = 400;
export var EVENT_TYPE = {
    ECG: '1',
    PPG: '2',
    RESPIRATION: '3',
    SYSTOLIC: '4',
    DIASTOLIC: '5',
    SPO2: '6',
    TEMPRATURE: '7',
    AF_ECG: '8',
    AF_PPG: '9',
    NO_MEASUREMENT: '11',
    ECG_LOW_QUALITY: '13',
    ECG_LEAD_ON: '15',
    OPEN_SENSOR: '17',
    BRADYCARDIA: '19',
    TACHYCARDIA: '21',
    PAUSE: '23',
    ON_CRADLE: '25',
    POWER_ON: '27',
    WEIGHT: '29',
    GLUCOSE: '30',
    RESPIRATION_MANUAL: '51',
    SYSTOLIC_MANUAL: '52',
    DIASTOLIC_MANUAL: '53',
    SPO2_MANUAL: '54',
    TEMPRATURE_MANUAL: '55',
    GLUCOSE_MANUAL: '56',
    WEIGHT_MANUAL: '57',
    SYSTOLIC_EXTERNAL: '71',
    DIASTOLIC_EXTERNAL: '72',
    SPO2_EXTERNAL: '73',
    TEMPRATURE_EXTERNAL: '74',
    STEPS: '31',
    CALORIES: '32'
};
export var dateFormats = {
    reportDateFull: 'MMM DD, YYYY, HH:mm A',
    tz: 'YYYY-MM-DDTHH:mm:ss.SSSZ',
    ms: 'YYYY-MM-DD HH:mm:ss.SSSSSS'
};
export var RT_END_STATUS = {
    STOPPED_EXIT: 3,
    STOPPED_COMPLETED: 4,
    STOPPED_ECG_AF_DETECTED: 5,
    STOPPED_ECG_AF_FAILED: 6,
    STOPPED_BY_DOCTOR: 7,
};
export var ANNOTATIONS_NAMES = {
    chest_pain: "Chest pain",
    discharge: "Discharge",
    dizziness: "Dizziness",
    fainting: "Fainting",
    fall: "Fall",
    fever: "Fever",
    hospital_admission: "Hospital Admission",
    meal: "Meal",
    nausea_vomiting: "Nausea / Vomiting",
    palpitation: "Palpitation",
    weakness: "Weakness",
    worsening_edema: "Worsening edema",
    "ibd_flare-up": "IBD Flare-up",
    epileptic_episode: "Epileptic seizure",
    heart_fail_treat: "Heart failure treatment",
};
export var AF_STATUS = {
    0: 'not_detected',
    1: 'detected',
    2: 'failed',
    3: 'failed', //we did not get a flag from the watch
    4: 'inconclusive' //in case that the watch indicate af and cardiolyse not
};
export var DAYS = {
    "1": "Sun",
    "2": "Mon",
    "3": "The",
    "4": "Wed",
    "5": "Thu",
    "6": "Fri",
    "7": "Sat"
};
export var LANGUAGES = [
    { languageTag: 'en', text: 'English', langCode: 0, isRTL: false }, //English
    { languageTag: 'he', text: 'עברית', langCode: 18, isRTL: false /*change to true after translation ready*/ }, //Hebrew
    { languageTag: 'ar', text: 'عربي', langCode: 19, isRTL: false /*change to true after translation ready*/ }, //Arabic
    { languageTag: 'fr', text: 'Français', langCode: 3, isRTL: false }, //French
    { languageTag: 'de', text: 'Deutsch', langCode: 1, isRTL: false }, //German
    { languageTag: 'hi', text: 'हिन्दी', langCode: 13, isRTL: false }, //Hindi
    { languageTag: 'it', text: 'Italiano', langCode: 2, isRTL: false }, //Italian
    { languageTag: 'ja', text: '日本', langCode: 16, isRTL: false }, //Japanese
    { languageTag: 'nl', text: 'Dutch', langCode: 8, isRTL: false }, //Dutch
    { languageTag: 'phi', text: 'Filipino', langCode: 7, isRTL: false }, //Phillipine
    { languageTag: 'pt', text: 'Português', langCode: 6, isRTL: false }, //Portuguese
    { languageTag: 'ru', text: 'Русский', langCode: 15, isRTL: false }, //Russian
    { languageTag: 'tr', text: 'Türkçe', langCode: 4, isRTL: false }, //Turkish
    { languageTag: 'vi', text: 'Tiếng Việt', langCode: 0, isRTL: false }, //Vietnamese
    { languageTag: 'zh', text: '中国人', langCode: 14, isRTL: false }, //Chinese
    { languageTag: 'es', text: 'Español', langCode: 9, isRTL: false }, //Spanish
    { languageTag: 'ca', text: 'Català', langCode: 5, isRTL: false }, //Catalan
    { languageTag: 'el', text: 'Ελληνικά', langCode: 17, isRTL: false }, //Greek
    { languageTag: 'pl', text: 'Polski', langCode: 10, isRTL: false }, //Polish
    { languageTag: 'ro', text: 'Română', langCode: 11, isRTL: false }, //Romanian
    { languageTag: 'hr', text: 'Hrvatski', langCode: 12, isRTL: false }, //Croatian
    { languageTag: 'th', text: 'ไทย', langCode: 20, isRTL: false }, //Thailand
    { languageTag: 'cz', text: 'čeština', langCode: 21, isRTL: false }, // Czech
    { languageTag: 'sk', text: 'slovenský', langCode: 22, isRTL: false }, // Slovak
];
//# sourceMappingURL=consts.js.map